import React from 'react';
import { useTranslation } from 'react-i18next';

export const ExportJobSelectionNotice = () => {
    const { t } = useTranslation();

    return (
        <p className="account-share-jobs--notice">
            <i>{t('management.excelExport.selection.notice.label')}</i>{' '}
            {t('management.excelExport.selection.notice.text')}
        </p>
    );
};

const ExportJobSelectionDescription = () => {
    const { t } = useTranslation();

    return <p>{t('management.excelExport.selection.description')}</p>;
};

export default ExportJobSelectionDescription;
